import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'

import { GlgLoadingSpinner } from 'SharedComponents'
import PaymentmethodNameComponent from './paymentmethod_name_component'
import Checkbox from '../../../dashboard/components/content/event_setup/checkbox'

class PaymentMethodsComponent extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let paymentMethods = []
    if (!this.props.dataIsLoading) {
      paymentMethods = Object.values(this.props.payments)
    }
    const paymentmethodTitle =
      <Row className='title'>{ !window.I18n ? '' : window.I18n.t('player_activity.registration.payment_methods.title') }</Row>

    return (
      <div className='payment-methods'>
        { paymentmethodTitle }
        { paymentMethods.length > 0 && this.props.savedCardPermissionEnabled &&
          <Checkbox
            className='col-xs-12'
            key='manager_card_permission'
            label={!window.I18n ? '' : window.I18n.t('invoice_stripe_entries.forms.fields.manager_card_permission')}
            selected={this.props.managerPermission}
            setOption={(v) => this.props.handleManagerPermission()}
          />
        }
        <Col className='col-xs-12'>
          <GlgLoadingSpinner show={ this.props.dataIsLoading }/>
          { paymentMethods.length === 0 && !this.props.dataIsLoading &&
            <p className='no-info'>
              { !window.I18n ? '' : window.I18n.t('player_activity.registration.payment_methods.no_saved_methods') }
            </p>
          }
          {
            paymentMethods.map((e, index) => {
              return (
                <Row className='no-lateral-margin' key={ index }>
                  <PaymentmethodNameComponent handleManagerPermission={this.props.handleManagerPermission} deletePaymentMethod={ this.props.deletePaymentMethod } defaultPaymentMethod={ this.props.defaultPaymentMethod } typeName={ e.type } expirationName={ e.expiration } lastdigitName={ e.last_4_digit } usedDefault={ e.used_default } cardholder={ e.cardholder } colSmSize={ 12 } id={e.id} />
                </Row>
              )
            })
          }
        </Col>
      </div>
    )
  }
}

PaymentMethodsComponent.propTypes = {
  payments: PropTypes.object,
  dataIsLoading: PropTypes.bool,
  target: PropTypes.string,
  deletePaymentMethod: PropTypes.func,
  defaultPaymentMethod: PropTypes.func,
  managerPermission: PropTypes.bool,
  handleManagerPermission: PropTypes.func,
  savedCardPermissionEnabled: PropTypes.bool,
}

export default PaymentMethodsComponent
